import { render, staticRenderFns } from "./deleteBusinessDatabus.vue?vue&type=template&id=60101ba7"
import script from "./deleteBusinessDatabus.vue?vue&type=script&lang=js"
export * from "./deleteBusinessDatabus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports